import classNames from "classnames";
import React, { FC } from "react";

type Props = {
  title: string;
  description: string;
  icon: React.ReactNode;
  noBorder?: boolean;
  onClick: () => void;
};
export const BillingSettingsCard: FC<Props> = ({
  title,
  description,
  icon,
  noBorder,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={
        "flex w-[400px] cursor-pointer items-center gap-4 rounded-xl border border-gray-200 bg-white p-6 font-Manrope"
      }>
      <div
        className={
          "flex h-[40px] w-[40px] items-center justify-center rounded-md bg-[#7C66F03D]"
        }>
        <div
          className={classNames(
            noBorder ? "" : "border border-[#6F55F0E8]",
            "flex h-[24px] w-[24px] items-center justify-center rounded-[5px] bg-white text-[#6F55F0E8]",
          )}>
          {icon}
        </div>
      </div>

      <div className={"flex flex-col justify-center"}>
        <div className={"text-lg font-semibold"}>{title}</div>
        <div className={"text-sm"}>{description}</div>
      </div>
    </div>
  );
};
